module.exports = __webpack_public_path__ + "static/media/Noirden-SemiBold-oblique.9388c6b1.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Noirden-SemiBold-oblique.otf
// module id = 3378
// module chunks = 70